import Instagram from '@mui/icons-material/Instagram';
import LinkedIn from '@mui/icons-material/LinkedIn';
import X from '@mui/icons-material/X';
import YouTube from '@mui/icons-material/YouTube';
import { IconButton } from '@mui/material';

export const SocialMediaIcons: React.FC = () => (
  <div>
    {[
      {
        href: 'https://twitter.com/givaudan',
        Icon: X
      },
      {
        href: 'https://www.linkedin.com/company/givaudan/',
        Icon: LinkedIn
      },
      {
        href: 'https://www.youtube.com/channel/UCYORWWrnAxS8nRMydo0qZeA/videos',
        Icon: YouTube
      },
      {
        href: 'https://www.instagram.com/givaudan/',
        Icon: Instagram
      }
    ].map(({ href, Icon }) => (
      <IconButton
        key={href}
        color="primary"
        href={href}
        target="_blank"
        rel="noopener"
      >
        <Icon />
      </IconButton>
    ))}
  </div>
);
